(() => {
  'use strict';

  if (window.__FTRLoopQuantityHotfixInstalled || typeof window.fetch !== 'function') return;
  window.__FTRLoopQuantityHotfixInstalled = true;

  const nativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init = {}) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const method = String(init?.method || input?.method || 'GET').toUpperCase();
    const isLoopBundleTransaction =
      method === 'POST' &&
      /api\.loopsubscriptions\.com\/storefront\/2023-10\/bundle\/[^/]+\/transaction(?:\?|$)/.test(url);

    if (!isLoopBundleTransaction || typeof init?.body !== 'string') {
      return nativeFetch(input, init);
    }

    try {
      const payload = JSON.parse(init.body);
      if (payload && (payload.quantity == null || Number(payload.quantity) <= 0)) {
        payload.quantity = 1;
        init = {
          ...init,
          body: JSON.stringify(payload)
        };
        console.log('[FTR Loop Quantity Fix] Added transaction quantity:', payload.quantity);
      }
    } catch (_) {}

    return nativeFetch(input, init);
  };
})();
